import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M12 8.4a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6m.7 3.225a.7.7 0 1 0-1.4 0V15.9a.7.7 0 1 0 1.4 0z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m8.2-2.8a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0m.8 1.725a.7.7 0 0 1 .7.7V15.9a.7.7 0 1 1-1.4 0v-4.275a.7.7 0 0 1 .7-.7"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
